<template>
  <v-row>
    <v-col cols="6">
      <CInput
        v-model="value.processo_judicial"
        :clearable="false"
        class="d-flex align-center"
        label="Processo Judicial"
        @input="$emit('update:value', 'processo_judicial')"
      />
    </v-col>

    <v-col cols="6">
      <CSelect
        v-model="value.transporte_proprio"
        :items="meiosTransporte"
        item-text="text"
        item-value="value"
        label="Meio de transporte próprio"
        required
        @input="$emit('update:value', 'transporte_proprio')"
      />
    </v-col>

    <v-col class="py-0">
      <v-switch
        v-model="value.vulnerabilidade_social"
        class="my-0 py-0"
        label="Criança em vulnerabilidade social"
        @change="$emit('update:value', 'vulnerabilidade_social')"
      >
      </v-switch>
    </v-col>

    <v-col class="py-0">
      <v-switch
        v-model="value.acolhimento_institucional"
        class="my-0 py-0"
        label="Acolhimento institucional"
        @change="$emit('update:value', 'acolhimento_institucional')"
      >
      </v-switch>
    </v-col>
  </v-row>
</template>

<script>
import CInput from "@/components/Input";
import CSelect from "@/components/Select";

const MEIOS_TRANSPORTE = [
  { text: "Não possui", value: "NAO_POSSUI" },
  { text: "Carro", value: "CARRO" },
  { text: "Moto", value: "MOTO" },
];

export default {
  name: "segunda-secao-processo",

  components: {
    CInput,
    CSelect,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      meiosTransporte: MEIOS_TRANSPORTE,
    };
  },
};
</script>
